export default __webpack_public_path__ + "static/ksm_card-dfadeacc5763a5d2250b946b5d4d123a.jpg";